import { useLocation } from "react-router-dom";

const useGetRouteHash = () => {
	const location = useLocation();

	return location.hash;
};

export default useGetRouteHash;
